import moment from 'moment';
import { camelizeKeys } from 'humps';
import axios from 'axios';

export const DEFAULT_MAXLENGTH = {
  TEXT: 100,
  TEXTAREA: 2000,
  CHECKLIST: 25,
};

export const conversionSeniorityInfo = (year) => {
  let yearDisplay = year;
  if (year < 0) {
    yearDisplay = 'N/A';
  } else if (year === null || year === undefined) {
    yearDisplay = '-';
  }
  return yearDisplay;
};

// 檢查日期是否正確
export const checkDateValid = (_time, format = 'YYYY/MM/DD') => {
  // 排除舊架構PA會以0001-01-01做為空值的情形
  const emptyTime = moment('0001-01-01', format);
  const time = moment(_time, format);
  return !emptyTime.isSame(time) && time.isValid();
};

// 檔案下載錯誤處理
export function parseAxiosDownloadError(error, callback) {
  const reader = new FileReader();
  reader.addEventListener('loadend', (event) => {
    const { result } = event.target;
    const response = camelizeKeys(JSON.parse(result));
    const errorMessage = {
      code: response.code,
      message: response.message,
    };
    return typeof callback === 'function' && callback(errorMessage);
  });
  reader.readAsText(error.response.data);
}

export function parseAxiosErrorMessage(payload, callback) {
  const data = camelizeKeys(payload.response.data);
  const errorMessage = {
    code: data.code,
    message: data.message,
    exception: data.exception || '',
  };
  return typeof callback === 'function' && callback(errorMessage);
}

export function pseudoLinkClick(blob, fileName) {
  // IE10+
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

export const fileAxios = axios.create({
  responseType: 'blob',
  transformResponse: (data) => data,
});



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/utils/index.js
 **/